import React from 'react';
import { Accordion } from './ui/Accordion';
import { AnimatedSection } from './ui/AnimatedSection';
const FAQS = [{
  q: '¿Es para estudiantes o profesionales?',
  a: 'Para ambos. Los estudiantes avanzados lo usan para conectar teoría y práctica; los profesionales, como material de consulta para revisar pruebas, evaluaciones y recursos terapéuticos.'
}, {
  q: '¿Qué recibo exactamente?',
  a: '6 tomos digitales y 5 herramientas de consulta rápida: 11 recursos organizados como un sistema de consulta.'
}, {
  q: '¿Es un curso?',
  a: 'No. No hay clases, videos ni cronograma. Es una biblioteca digital organizada para que vayas directamente a lo que necesitas revisar.'
}, {
  q: '¿Es una aplicación o software?',
  a: 'No. No es software, aplicación ni plataforma. Son documentos digitales que abres y consultas desde tu celular, tablet o computadora.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'El acceso es 100% digital y se habilita después de completar la compra. Puedes acceder desde cualquier país.'
}, {
  q: '¿El pago es único?',
  a: 'Sí. Son US$12.99 en un solo pago, sin mensualidades ni suscripciones.'
}, {
  q: '¿Cómo funciona la garantía?',
  a: 'Dispones de 7 días para revisar el material y solicitar la devolución según las condiciones de garantía.'
}];
export function FAQ() {
  return <AnimatedSection className="bg-white py-10 sm:py-14" data-id="element-99" data-mp="11x8pzdg4ymh2">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100" data-mp="11vnv1mpwt1io">
        <h2 className="font-heading font-extrabold text-navy-950 text-[1.3rem] sm:text-[2rem] text-center leading-tight tracking-tight mb-5 sm:mb-7" data-id="element-101" data-mp="16o7ayqc2k8qn">
          Preguntas frecuentes
        </h2>

        <div className="space-y-1.5" data-id="element-102" data-mp="wxmcd2web47q">
          {FAQS.map(faq => <Accordion key={faq.q} question={faq.q} answer={faq.a} data-id="element-103" data-mp="iycywazkqo7g" />)}
        </div>
      </div>
    </AnimatedSection>;
}